import React from 'react'
import SpinnerGiff from '../../assets/Spinner1.svg'

// Loading Spinner Full screen Component

const LoadingScreen = () => {
  return (
    <div style={{zIndex:'999999999999'}} className="fixed inset-0 h-screen bg-white pt-5 flex justify-center items-center overflow-hidden">
      <img src={SpinnerGiff} alt="..." />
        </div>
  )
}

export default LoadingScreen
